/**
 * Normalize what a customer types for their Desk workspace: slug, slug-domain
 * (`ttg.desk.meshtek.io`, with or without scheme/path) or a vanity domain.
 * Slug-domain forms reduce to the slug; a vanity domain is kept whole (Desk
 * resolves tenants by slug OR custom domain, desk-integration.md §9). Used by
 * signup, Settings and the SPA so every entry point means the same thing.
 */
export function normalizeDeskWorkspace(raw) {
    const v = raw
        .trim()
        .toLowerCase()
        .replace(/^https?:\/\//, '')
        .replace(/\/.*$/, '');
    for (const suffix of ['.desk.meshtek.io', '.desk-staging.meshtek.io']) {
        if (v.endsWith(suffix))
            return v.slice(0, -suffix.length);
    }
    return v;
}
//# sourceMappingURL=desk-workspace.js.map